export const FETCH_ALL_ASSESSMENT_LIST_REQUEST = "FETCH_ALL_ASSESSMENT_LIST_REQUEST";
export const FETCH_ALL_ASSESSMENT_LIST_SUCCESS = "FETCH_ALL_ASSESSMENT_LIST_SUCCESS";
export const FETCH_ALL_ASSESSMENT_LIST_FAILURE = "FETCH_ALL_ASSESSMENT_LIST_FAILURE";

export const RESET_ALL_ASSESSMENT_LIST_DATA = "RESET_ALL_ASSESSMENT_LIST_DATA";
